var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiMenuBarIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.76,
    filter: "url(#filter0_d_405_2045)",
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6484 18.4922C13.7318 18.4922 13.8151 18.4661 13.8984 18.4141C13.987 18.362 14.1042 18.2656 14.25 18.125L16.0781 16.3672C16.1406 16.3099 16.1745 16.2448 16.1797 16.1719C16.1901 16.0938 16.1693 16.0208 16.1172 15.9531C15.8724 15.6354 15.5312 15.3594 15.0938 15.125C14.6615 14.8906 14.1797 14.7734 13.6484 14.7734C13.1068 14.7734 12.6146 14.8958 12.1719 15.1406C11.7344 15.3854 11.3932 15.6719 11.1484 16C11.112 16.0573 11.099 16.1198 11.1094 16.1875C11.125 16.25 11.1641 16.3099 11.2266 16.3672L13.0547 18.125C13.1953 18.2656 13.3099 18.362 13.3984 18.4141C13.487 18.4661 13.5703 18.4922 13.6484 18.4922ZM9.25781 14.3906C9.33594 14.4688 9.42188 14.5052 9.51562 14.5C9.60938 14.4948 9.69531 14.4505 9.77344 14.3672C10.2214 13.862 10.7917 13.4479 11.4844 13.125C12.1771 12.8021 12.8984 12.6432 13.6484 12.6484C14.4089 12.6432 15.1354 12.8073 15.8281 13.1406C16.5208 13.4688 17.0964 13.8854 17.5547 14.3906C17.6276 14.4688 17.7083 14.5078 17.7969 14.5078C17.8854 14.5026 17.9661 14.4609 18.0391 14.3828L19.2031 13.2344C19.2656 13.1719 19.2995 13.1042 19.3047 13.0312C19.3099 12.9531 19.2865 12.8802 19.2344 12.8125C18.8542 12.349 18.3776 11.9349 17.8047 11.5703C17.2318 11.2005 16.5911 10.9115 15.8828 10.7031C15.1745 10.4896 14.4297 10.3828 13.6484 10.3828C12.8672 10.3828 12.1224 10.4896 11.4141 10.7031C10.7109 10.9115 10.0729 11.2005 9.5 11.5703C8.92708 11.9349 8.45052 12.349 8.07031 12.8125C8.01302 12.8802 7.98698 12.9505 7.99219 13.0234C7.9974 13.0964 8.03125 13.1667 8.09375 13.2344L9.25781 14.3906ZM6.13281 11.2578C6.20573 11.3359 6.28906 11.375 6.38281 11.375C6.48177 11.3698 6.5651 11.3281 6.63281 11.25C7.5599 10.2708 8.61979 9.52865 9.8125 9.02344C11.0052 8.51302 12.2839 8.25781 13.6484 8.25781C15.0182 8.25781 16.2995 8.51302 17.4922 9.02344C18.6901 9.53385 19.75 10.2786 20.6719 11.2578C20.7396 11.3255 20.8203 11.3594 20.9141 11.3594C21.0078 11.3594 21.0885 11.3203 21.1562 11.2422L22.1875 10.2031C22.2552 10.1406 22.2891 10.0703 22.2891 9.99219C22.2943 9.90885 22.2708 9.83594 22.2188 9.77344C21.6302 9.04948 20.888 8.40365 19.9922 7.83594C19.0964 7.26302 18.1042 6.8151 17.0156 6.49219C15.9323 6.16406 14.8099 6 13.6484 6C12.487 6 11.362 6.16406 10.2734 6.49219C9.1849 6.8151 8.19271 7.26302 7.29688 7.83594C6.40625 8.40365 5.66667 9.04948 5.07812 9.77344C5.02604 9.83594 5 9.90885 5 9.99219C5.00521 10.0703 5.03906 10.1406 5.10156 10.2031L6.13281 11.2578Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_405_2045",
    x: 1,
    y: 4,
    width: 25.29,
    height: 20.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_405_2045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_405_2045",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiMenuBarIcons);
export default __webpack_public_path__ + "static/media/wifi_MenuBarIcons.eb3077298afb9ac2e9e48aecdca2b9d4.svg";
export { ForwardRef as ReactComponent };